import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { ResultType } from 'constants/resultType';

import { Listing } from './listing';
import { MessagingCard } from 'components/common/messaging-card/messaging-card';
import { SearchCarousel } from 'src/common/components/common/search-carousel';

export interface ResultProps {
  className: string;
  endDate: string;
  index: number;
  lazyLoadImg: boolean;
  loading: boolean;
  model: any;
  resultType: ResultType;
  startDate: string;
  setResultRef?: (ref: HTMLElement, index: number) => void;
  analytics?: AnalyticsStore;
  stidKey?: string;
  type?: string;
  lazyLoad?: boolean;
}

export const Result = (props: ResultProps) => {
  const { resultType, ...rest } = props;

  let ResultComponent;

  switch (resultType) {
    case ResultType.MESSAGING:
      ResultComponent = MessagingCard;
      break;
    case ResultType.CAROUSEL:
      ResultComponent = SearchCarousel;
      break;
    case ResultType.HOTEL:
    default:
      ResultComponent = Listing;
  }

  return <ResultComponent {...rest} />;
};
